import React,{useState} from 'react'
import Validation from '../../../Helper/validations/vaildation';

const AssignMedicineFunction = () => {

    const defaultValues = {
        brandName: null,
        medicine: null,
        salt: null,
        dosage:null,
        route: null,
        tags:[]
    }

 const defaultErrors = {
        brandName: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        medicine: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        salt: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        dosage: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        route :{
            rules: ["required"],
            isValid: true,
            message: "",
        },
        tags: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
    };

    const [values, setValues] = useState(defaultValues)
    const [isError, setError] = useState(defaultErrors); 
    const [loader, setLoader] = useState(false);
    const breadcrumData = ['Dashboard', 'Patient Detail'];
    const breadcrumItem = ['Assign Medicine'];
    const [tags, setTags] = useState([]);
    const [numMedicine, setNumMedicine] = useState([])
    
    const handleChange = (field, value) => {
        let validation = new Validation(isError);
        let node = validation.validateField(field, value);
        setError({ ...isError, [field]: node });
        setValues({ ...values, [field]: value });
    };
    
    const anotherMedicine = (item) => {
        let array = [...numMedicine];
        let index = array.indexOf(item);
        if (index > -1) {           
            array.splice(index, 1);
        } else {
             array.push('1')
        } 
        setNumMedicine(array)
    } 

     const handleSubmit = async () => {
        setLoader(true);
        let validation = new Validation(isError);
        let isValid = validation.isFormValid(values);
        if (isValid && !isValid.haveError) {
            setLoader(false);
        } else {
            setLoader(false);
            setError({ ...isValid.errors });
        }
        setLoader(false);
    };
    console.log(values,"<<-------Dvalues===");

    return {
        breadcrumData,
        breadcrumItem,
        tags,
        values,
        isError,
        handleChange,
        handleSubmit,
        loader,
        anotherMedicine,
        numMedicine
  }
}

export default AssignMedicineFunction